// Shared mode descriptions used when configuring and receiving an invite.
export const MODES = [
  {
    id: "full",
    label: "Full practice interview",
    tag: "PRACTICE INTERVIEW · 20–30 MIN",
    desc: "20–30 min · Complete end-to-end interview with all core question categories, scored debrief, and full feedback report.",
  },
  {
    id: "qualifier_prep",
    label: "Pre-meeting warm-up",
    tag: "WARM-UP · 5–10 MIN",
    desc: "5–10 min · Quick warm-up before a recruiter meeting: TMAY + one competency question + closing pitch. Use this to help a candidate feel confident and grounded immediately before their recruiter conversation.",
  },
  {
    id: "tmay-drill",
    label: "TMAY Drill",
    tag: "TMAY · 5 MIN",
    desc: "~5 min · Three reps of the Tell Me About Yourself opener, with structured feedback on narrative, energy, and brevity.",
  },
  {
    id: "pcar-drill",
    label: "PCAR Drill",
    tag: "PCAR · 10 MIN",
    desc: "~10 min · Behavioural questions using the Problem–Context–Action–Result framework. Focuses on specificity and impact.",
  },
  {
    id: "outro-pitch",
    label: "Outro Pitch Drill",
    tag: "OUTRO · 5 MIN",
    desc: "~5 min · Three reps of closing pitch — how the candidate summarises fit and leaves a strong final impression.",
  },
  {
    id: "question-asker",
    label: "Question-Asker Drill",
    tag: "Q-ASKER · 5 MIN",
    desc: "~5 min · Candidate asks questions of the interviewer. Scores quality, commercial awareness, and timing.",
  },
] as const;

/** Use the same estimate candidates were offered by their recruiter. */
export function modeDuration(mode: string): string | null {
  const entry = MODES.find((item) => item.id === mode);
  const minutes = entry?.tag.match(/· (.+) MIN$/)?.[1];
  return minutes ? `${minutes} minutes` : null;
}
